import { StateProvider, Transition } from '@uirouter/angularjs';
import { Helpers } from '../../helpers';

export const publicStateName = 'app.public';

export function publicRoutesConfig( $stateProvider: StateProvider ) {
  $stateProvider
    .state(`${publicStateName}`, {
      abstract: true,
      component: 'public'
    })
    .state(`${publicStateName}.privacy.**`, {
      url: '/privacy',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { PrivacyModule } = await import('../privacy/privacy.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(PrivacyModule.name);
      }
    })
    .state(`${publicStateName}.terms.**`, {
      url: '/terms',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { TermsModule } = await import('../terms/terms.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(TermsModule.name);
      }
    })
    .state(`${publicStateName}.faq`, {
      url: '/public-faq',
      component: 'faq',
      resolve: {
        $title: () => 'F.A.Q.'
      },
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { FaqModule } = await import('../faq/faq.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(FaqModule.name);
      }
    })
    .state(`${publicStateName}.landing`, {
      url: '/',
      component: 'landing',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { LandingModule } = await import('../landing/landing.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(LandingModule.name);
      }
    });
}

publicRoutesConfig.$inject = [
  '$stateProvider'
];



// WEBPACK FOOTER //
// ./app/states/public/public-routing.ts